import { TextControl, PanelRow } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { __ } from '@wordpress/i18n'
import Select from 'react-select'

export default (props) => {
    let allData = props.data 
    const {pricing_type}  = allData;
    const { updateTripData } = dispatch('WPTravel/TripEdit')

    let pricingTypes = [
        {label: __( 'Multiple Pricing', 'wp-travel-pro' ), value: 'multiple-price' },
        {label: __( 'Custom Booking', 'wp-travel-pro' ), value: 'custom-booking'}
    ]
    let selectedPricingType = pricingTypes.filter( (t) => { return t.value == pricing_type } )
    selectedPricingType = 'undefined' != typeof selectedPricingType[0] ? selectedPricingType[0] : {}

    return  <>
        <div className="wp-travel-select-pricing">
            <PanelRow>
                <label>{__( 'Select Pricing', 'wp-travel-pro' )}</label>
                <div className="wp-travel-select-wrapper">
                    <Select
                        options={pricingTypes}
                        defaultValue={ selectedPricingType }
                        onChange={(val)=>{
                            if ( '' !== val ) {
                                let spt = pricingTypes.filter( data => {
                                    return val.label == data.label
                                } ).map( data => {
                                    return data.value
                                } );
                                spt = 'undefined' != typeof spt[0] ? spt[0] : {}
                                updateTripData({
                                    ...allData, // allData
                                    pricing_type: spt
                                })
                            }
                        }}

                    />
                </div>
            </PanelRow>
        </div>
        </>
}